import { ShowcaseVariant } from '../domain/types/showcaseTypes';

export const showcaseVariantLabels: Record<ShowcaseVariant, string> = {
  STANDARD: 'Standard',
  LUXURY: 'Lusso',
};
